
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.423 22H7.654a2.195 2.195 0 01-2.192-2.192V7.385H4V5.923h4.385v-.736A2.189 2.189 0 0110.571 3h2.935a2.189 2.189 0 012.186 2.187v.736h4.385v1.462h-1.462v12.423A2.195 2.195 0 0116.423 22zm-9.5-14.615v12.423a.723.723 0 00.731.731h8.769a.723.723 0 00.731-.731V7.385zm3.648-2.923a.709.709 0 00-.724.725v.736h4.385v-.736a.709.709 0 00-.725-.725zm2.2 14.615h-1.463V8.846h1.462v10.23zm-2.923 0H8.385V8.846h1.461v10.23zm5.845 0h-1.462V8.846h1.461v10.23z","fill":"currentColor"}})])
          )
        }
      }
    